// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__wXfRu","form":"styles_form__6jqmZ","illustration":"styles_illustration__vdgKe"};